import { DataResponse } from './Data';

export class RulesResponse {
  /**
   * constructor description
   * @param {Object} response - An object.
   * @param  {Data} response.data
   * @param  {Boolean} response.success
  */
  constructor({ data, success }) {
    this.data = new DataResponse(data);
    this.success = success;
  }
}
